// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const getQueryStringParams = (win?: Window): any => {
  return decodeURI((win || window).location.search)
    .replace("?", "")
    .split("&")
    .map((param) => param.split("="))
    .reduce((values: any, [key, value]) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      values[key] = value;
      return values;
    }, {});
};
